/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: dropdown-button-component.ts
 *
 * Created by kyang on 2019-11-05.
 */

function DropdownButtonController (
    this: JS5Object,
    _: JS5Object,
    DropdownService: JS5Object,
) {

    //===================//
    // Template Response //
    //===================//

    this.getButtonText = () => {
        if (this.dropdownConfig.filter.length > 0) {
            return this.dropdownConfig.filter;
        }
        if (this.selectService.hasSelection(this.dropdownConfig)) {
            return this.selectService.getSelectionText(this.dropdownConfig);
        }
        return DropdownService.getPrompt(this.dropdownConfig);
    };

    this.toggleDropDown = (event: JS5Object) => {
        event.preventDefault();
        event.stopPropagation();
        this.onDropdownToggled();
    };

    this.canClearSelection = () => {
        return !!this.dropdownConfig.clearable && this.selectService.hasSelection(this.dropdownConfig);
    };

    this.onClearClicked = () => {
        this.selectService.clearSelection(this.dropdownConfig);
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    // this.$onChanges = () => {
    // };

    // this.$onInit = () => {
    // };
}

angular.module('prism-ui.components').component(
    'dropdownButton',
    {
        bindings: {
            selectService: '<',
            dropdownConfig: '<',
            onDropdownToggled: '&',

            btnMinWidth: '<?',
            isDisabled: '<ngDisabled',
        },
        controller: DropdownButtonController,
        templateUrl: 'components/visual/dropdown/dropdownButton/dropdown-button-template.html'
    });
